import { reduce } from "lodash";
import {
  SIZE_AUTO,
  SIZE_GRANDE,
  SIZE_LARGE,
  SIZE_L_MEDIUM,
  SIZE_MEDIUM,
  SIZE_NO,
  SIZE_SMALL,
  SIZE_SS_MEDIUM,
  SIZE_S_MEDIUM,
  SIZE_XX_GRANDE,
  SIZE_XX_LARGE,
  SIZE_XX_SMALL,
  SIZE_X_GRANDE,
  SIZE_X_LARGE,
  SIZE_X_SMALL,
} from "./sizes";

export const mapper = (
  properties: string | undefined,
  map: { [key: string]: string | number },
  defaultValue: string = SIZE_MEDIUM
) =>
  reduce(
    (properties || defaultValue).split(" "),
    (result, property) => `${result} ${map[property]} `,
    ""
  ).trim();

const SIZE_MAP = {
  [SIZE_AUTO]: "auto",
  [SIZE_NO]: "0",
  [SIZE_XX_SMALL]: "0.313rem" /* 5px */,
  [SIZE_X_SMALL]: "0.625rem" /* 10px */,
  [SIZE_SMALL]: "0.938rem" /* 15px */,
  [SIZE_S_MEDIUM]: "1.25rem" /* 20px */,
  [SIZE_SS_MEDIUM]: "1.563rem" /* 25px */,
  [SIZE_MEDIUM]: "1.875rem" /* 30px */,
  [SIZE_L_MEDIUM]: "2.5rem" /* 40px */,
  [SIZE_LARGE]: "3.125rem" /* 50px */,
  [SIZE_X_LARGE]: "3.75rem" /* 60px */,
  [SIZE_XX_LARGE]: "4.375rem" /* 70px */,
  [SIZE_GRANDE]: "7.5rem" /* 120px */,
  [SIZE_X_GRANDE]: "9.375rem" /* 150px */,
  [SIZE_XX_GRANDE]: "11.25rem" /* 180px */,
};

export const sizeMapper = (size?: string, defaultSize: string = SIZE_MEDIUM) =>
  mapper(size, SIZE_MAP, defaultSize);
